import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class CorporationPaymenetServiceRecord extends RecordBase {

  static defaultAttributes = {
    is_fixed:                  false,
    fixed_amount:              null,
    excess_price:              null,
    price:                     null,
    payment_service:           null,
    payment_wallet:            null,
    payment_method:            null,
    created_at:                '',
    updated_at:                '',
    is_include_corporation_branches: false,
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`corporationPaymentServices.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        is_fixed:           trAttr('is_fixed'),
        fixed_amount:       trAttr('fixed_amount'),
        excess_price:       trAttr('excess_price'),
        price:              trAttr('price'),
        payment_service:    trAttr('payment_service'),
        payment_wallet:     trAttr('payment_wallet'),
        payment_method:     trAttr('payment_method'),
        created_at:         trAttr('created_at'),
        updated_at:         trAttr('updated_at'),
        is_include_corporation_branches: trAttr('is_include_corporation_branches'),
      };
    }

    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      is_fixed,
      fixed_amount,
      excess_price,
      price,
      created_at,
      updated_at,
      is_include_corporation_branches,
    } = this.toObject();

    return {
      data:{
        attributes:{
          is_fixed,
          fixed_amount,
          excess_price,
          price,
          is_include_corporation_branches,
          payment_service_id: dig(this.get('payment_service'), 'id') || null,
          payment_wallet_id: dig(this.get('payment_wallet'), 'id') || null,
          payment_method_id: dig(this.get('payment_method'), 'id') || null,
          created_at,
          updated_at,
          ...attrs
        }
      }
    };
  }
}
